import React from 'react';
import { Waypoint } from 'react-waypoint';

export interface Props {
  rowIdx: number;
  onOffsetReached?: (offset: number) => void;
  children?: React.ReactNode;
}

const OffsetTracking: React.FC<React.PropsWithChildren<Props>> = ({
  onOffsetReached,
  rowIdx,
  children,
}) => {
  if (!onOffsetReached) {
    return <>{children}</>;
  }

  return (
    <Waypoint
      fireOnRapidScroll={false}
      bottomOffset={'90%'}
      onEnter={() => onOffsetReached(rowIdx)}
    >
      {children}
    </Waypoint>
  );
};
OffsetTracking.displayName = 'OffsetTracking';

export default OffsetTracking;
